import type { AxiosRequestConfig } from 'axios';
import { apiClient } from '@/shared/api/client';

export const downloadServerFile = async (
  url: string,
  filename: string,
  config: AxiosRequestConfig = {}
): Promise<void> => {
  const response = await apiClient.request<Blob>({ ...config, url, responseType: 'blob' });
  const objectUrl = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
};
